module.exports = __webpack_public_path__ + "static/img/wheelchair.aada3ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wheelchair.png
// module id = ta7E
// module chunks = 1